import { render, staticRenderFns } from "./ViewRolePage.vue?vue&type=template&id=137170d2&scoped=true&"
import script from "./ViewRolePage.vue?vue&type=script&lang=js&"
export * from "./ViewRolePage.vue?vue&type=script&lang=js&"
import style0 from "./ViewRolePage.vue?vue&type=style&index=0&id=137170d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137170d2",
  null
  
)

export default component.exports